import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CommunicationSubjectEnum } from '../enum/communication-subject-enum';

@Injectable({
    providedIn: 'root'
})
export class CommunicationProxyService {
    private communicationSubject: Subject<CommunicationProxyData> = new Subject<CommunicationProxyData>();

    constructor() {
    }

    public subscribe(subject: CommunicationSubjectEnum, callback) {
        return this.communicationSubject.subscribe((parameters: CommunicationProxyData) => {
            if (parameters.subject === subject) {
                callback(parameters);
            }
        });
    }

    public publishMessage(subject: CommunicationSubjectEnum, message: any) {
        this.communicationSubject.next(new CommunicationProxyData(subject, message));
    }
}

export class CommunicationProxyData {
    constructor(subject: CommunicationSubjectEnum, message: any) {
        this.subject = subject;
        this.message = message;
    }

    subject: CommunicationSubjectEnum;
    message: any;
}
